import './applied_filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedNumericView extends Monitoring.Views.SocialContents.Filters.AppliedFilterView
  template: JST['backbone/templates/monitoring/filters/applied_numeric']
  fieldName: 'numeric'

  events:
    'click #applied_followers_count a.remove-filters': 'removeFilter'

  initialize: ({searchQuery, title}) ->
    @searchQuery = searchQuery
    @title = title

  render: ->
    @$el.html(
      @template(
        title: @title
        min: @searchQuery.get("min_#{@fieldName}")
        max: @searchQuery.get("max_#{@fieldName}")
      )
    )
    @

  removeFilter: ->
    @searchQuery.resetField("min_#{@fieldName}")
    @searchQuery.resetField("max_#{@fieldName}")
    @_triggerQueryChanged()

  _triggerQueryChanged: =>
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)
